module.exports = __webpack_public_path__ + "img/explanation.557fd917.png";